import { createSelector } from 'reselect';
import { IMonitoringStore } from '@modules/monitoring/types';

// Возвращает размеры карты и таблиц для ресайзера
export const resizerSelector = createSelector(
  (state: IMonitoringStore) => state.MonitoringEventDetails.resizer,
  (resizer) => resizer
);
